import LearnPageLayout from "@/components/LearnPageLayout";
import { page2 } from "./learnDataP2";

/**
 * Static route wrapper for /learn/what-is-tms-therapy-for-depression.
 * Using an explicit static route (not a /learn/:slug param) ensures the
 * platform's static generator prerenders the full article HTML so crawlers
 * and AI search systems can read the educational content.
 */
const WhatIsTmsTherapyPage = () => (
  <LearnPageLayout
    title={page2.title}
    description={page2.description}
    canonical={page2.canonical}
    h1={page2.h1}
    breadcrumbLabel={page2.breadcrumbLabel}
    crumbs={page2.crumbs}
    shortAnswer={page2.shortAnswer}
    keyTakeaways={page2.keyTakeaways}
    sections={page2.sections}
    faqs={page2.faqs}
    sources={page2.sources}
    schemaJson={page2.schemaJson}
    relatedLinks={page2.relatedLinks}
    reviewBlock={page2.reviewBlock}
  />
);

export default WhatIsTmsTherapyPage;
